<template>
  <div>
    <WuMaoProjectOverview v-if="isWuMaoAccount" />
    <ChengKuangProjectOverview v-else />
  </div>
</template>

<script>
  import ChengKuangProjectOverview from './chengkuang/projectOverview.vue';
  import WuMaoProjectOverview from './wumao/projectOverview.vue';
  export default {
    name: 'projectOverview',
    components: {
      ChengKuangProjectOverview,
      WuMaoProjectOverview,
    },
  };
</script>

<style lang="scss" scoped></style>
